<ul class="breadcrumb">
  <li *ngFor="let breadcrumb of breadcrumbs"
     [ngClass]="isMob ? 'breadcrumb-item-mob' : 'breadcrumb-item'">
    <a routerLink="{{breadcrumb.url}}" (click)="breadCrumClicked(breadcrumb.url)">
      {{ breadcrumb.label }}
    </a>
  </li>
</ul>

